import {
  DiagnosisCertaintyTypeEnum,
  DiagnosisSourceEnum,
} from '@dermloop/static-values';
import { Exclude } from 'class-transformer';
import { IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { BaseCreateDto, BaseDto } from '../base.dto';
import { DiagnosticDifficultyDto } from '../clinical-details';
import { DiagnosisDto } from './diagnosis.dto';
import { DifferentialDiagnosisDto } from './differential-diagnosis.dto';

export interface ConditionDiagnosisDto extends BaseDto {
  conditionId: string;
  /** @deprecated Use conditionId */
  skinConditionId?: string;
  primaryDiagnosis: DiagnosisDto;
  difficulty?: DiagnosticDifficultyDto;
  secondaryDiagnosis?: DiagnosisDto;
  tertiaryDiagnosis?: DiagnosisDto;
  differentialDiagnoses?: DifferentialDiagnosisDto[];
  diagnosisSource: DiagnosisSourceEnum;
  diagnosisCertaintyType: DiagnosisCertaintyTypeEnum;
  note?: string;
}

export class CreateConditionDiagnosisDto
  extends BaseCreateDto
  implements Partial<ConditionDiagnosisDto>
{
  @IsOptional()
  @IsUUID()
  conditionId?: string;

  @IsOptional()
  @IsUUID()
  /** @deprecated Use conditionId */
  skinConditionId?: string;

  @IsUUID()
  primaryDiagnosisId: string;

  @Exclude()
  primaryDiagnosis?: never;

  @IsOptional()
  difficulty?: DiagnosticDifficultyDto;

  @IsOptional()
  @IsUUID()
  secondaryDiagnosisId?: string;

  @Exclude()
  secondaryDiagnosis?: never;

  @IsOptional()
  @IsUUID()
  tertiaryDiagnosisId?: string;

  @Exclude()
  tertiaryDiagnosis?: never;

  @IsEnum(DiagnosisSourceEnum)
  diagnosisSource: DiagnosisSourceEnum;

  @IsOptional()
  @IsUUID('all', { each: true })
  differentialDiagnosisIds?: string[];

  @Exclude()
  differentialDiagnoses?: never;

  @IsEnum(DiagnosisCertaintyTypeEnum)
  diagnosisCertaintyType: DiagnosisCertaintyTypeEnum;

  @IsOptional()
  @IsString()
  note?: string;
}
